import _ from 'lodash'
import { ACTION_TYPES } from '../constants/ActionTypes'
import { isDynamicColorMode, resolveColorValue, staticFieldMap } from '../dynamicColors.utils'
import { Map } from 'immutable'

export const alterTrackerOptions = (retState, parentUID, isProjectElm, stepID, layoutMode, pageID, options) => {
  return retState.setIn(
    parentUID === 'Header' || parentUID === 'Footer' || isProjectElm
      ? ['project', 'Settings', 'elements', stepID, 'props', layoutMode, 'options']
      : ['pages', pageID, 'Props', 'elements', stepID, 'props', layoutMode, 'options'],
    options
  )
}

export const getFieldStateByPath = (state, path) => {
  return state.getIn(['state', ...path.split(':')], null)
}

/** @param {any} localActionValue */
export const getLocalActionValueExists = (localActionValue) =>
  [
    ACTION_TYPES.SET_VALUE,
    ACTION_TYPES.SET_PARAM,
    ACTION_TYPES.SET_VALUE_FROM,
    ACTION_TYPES.SET_OPTIONS_FROM,
    ACTION_TYPES.SET_PARAM_FROM,
    ACTION_TYPES.SET_PARAM_FROM,
    'postMessage',
    ACTION_TYPES.SET_COLOR,
    ACTION_TYPES.SET_BG,
    ACTION_TYPES.SET_BORDER,
    'runAnimation',
    ACTION_TYPES.SET_VALUE_CUSTOM,
  ].indexOf(localActionValue) > -1

export const shouldApplyAction = (localAction, localValueFrom) => {
  const isOneOf = [ACTION_TYPES.SET_VALUE_FROM, ACTION_TYPES.SET_OPTIONS_FROM, ACTION_TYPES.SET_PARAM_FROM].includes(
    localAction.value
  )
  return isOneOf && (_.isEmpty(localValueFrom) || !localValueFrom?.value)
}

/**
 * @param {'static' | 'dynamic'} colorMode
 * @param {Map} actionTarget
 * @param {Map} retState
 * @returns {string}
 */
export function getColorValue(colorMode, actionTarget, retState) {
  if (isDynamicColorMode(colorMode)) {
    return resolveColorValue(actionTarget, retState)
  }

  const type = actionTarget.get('type')

  return actionTarget.getIn(staticFieldMap[type], '')
}

/**
 * @param {Map} action
 * @param {string[]} keyPath
 * @param {string[]} colorKeyPath
 * @param {string} colorValue
 * @param {string[]} rules
 * @returns {string}
 */
export function getTransformActionRules(action, keyPath, colorKeyPath, colorValue, rules) {
  const type = action.get('type')

  const rulesPathMap = {
    set_bg_color: keyPath,
    set_color: colorKeyPath,
    set_border_color: [...keyPath, 'borderColor'],
  }

  return _.set(rules, rulesPathMap[type], colorValue)
}
